import { Component, Input } from '@angular/core';

@Component({
  selector: 'slotcom-box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.scss'],
  standalone: true,
})
export class BoxComponent {
  @Input() classes: Array<string> = [];
}
